
export default {
    name: 'FAQNavigation',
    props: {
        links: {
            type: Array,
            default() {
                return [];
            },
            validator(links) {
                return links.every(link => link.text && link.name);
            }
        },
        animate: {
            type: Boolean,
            default: true
        },
        isRoute: {
            type: Boolean,
            default: true
        },
        currentSection: {
            type: Object
        }
    },
    data() {
        return {
            timer: null
        }
    },
    computed: {
        currentItem() {
            return this.links.find(({ name }) => this.$route.name === name) || null;
        }
    },
    mounted() {
        if (this.amimate && this.currentItem) setTimeout(this.backToCurrentItem, 500); // Костыль из-за шрифта, потом убрать
    },
    methods: {
        handleClickName(link) {
            this.$emit('change-section', link);
        },
        handleMouseout(e) {
            this.timer = setTimeout(this.backToCurrentItem, 500);
        },
        handleMouseover(e) {
            this.setStyleLineItem(e.target);
            clearTimeout(this.timer);
        },
        setStyleLineItem(item) {
            const wrLeft = this.$refs.wrapper.offsetLeft;
            const { width, left } = item.getBoundingClientRect();
            this.$refs['line-item'].style.width = `${width}px`;
            this.$refs['line-item'].style.transform = `translateX(${left - wrLeft}px)`;
        },
        backToCurrentItem() {
            if (!this.currentItem) {
                this.setDefault();
            } else if (this.currentItem) {
                const [item] = this.$refs[`link-${this.currentItem.name}`];
                this.setStyleLineItem(item.$el);
            }
        },
        setDefault() {
            this.$refs['line-item'].style.width = `0px`;
            this.$refs['line-item'].style.transform = `translateX(0px)`;
        }
    },
}
